export const MIN_ATTENDEE_COUNT = 2;

/**
 * Determines if a calendar event should be shown in meeting lists.
 * By default, attendee-free events are visible alongside events that have at
 * least MIN_ATTENDEE_COUNT attendees or a video conferencing link.
 */
export const shouldShowMeeting = (
  attendeeCount: number | null | undefined,
  meetLink: string | null | undefined,
  showCalendarEventsWithNoAttendees = true
): boolean => {
  const count = attendeeCount ?? 0;
  return (
    count >= MIN_ATTENDEE_COUNT ||
    (!!meetLink && meetLink.trim().length > 0) ||
    (showCalendarEventsWithNoAttendees && count === 0)
  );
};
